import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@4.0.0-alpha.1_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@9.28.0_j_633be32197f66cf8017f3e9c7ef861f9/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}